(() => {
  const body = document.body;
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-menu-overlay]');

  const setMenu = (open) => {
    if (!menu || !overlay || !toggle) return;
    if (open) {
      menu.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        menu.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
      body.classList.add('menu-open');
      close?.focus();
    } else {
      menu.classList.remove('is-open');
      overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      body.classList.remove('menu-open');
      setTimeout(() => {
        menu.hidden = true;
        overlay.hidden = true;
      }, 350);
      toggle.focus();
    }
  };

  toggle?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  overlay?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && body.classList.contains('menu-open')) setMenu(false);
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const optionInputs = [...form.querySelectorAll('input[name^="options"]')];
    if (!variantSelect || optionInputs.length === 0) return;
    optionInputs.forEach((input) => input.addEventListener('change', () => {
      const selected = optionInputs.filter((item) => item.checked).map((item) => item.value);
      const matching = [...variantSelect.options].find((option) => selected.every((value) => option.text.includes(value)));
      if (matching) variantSelect.value = matching.value;
    }));
  });
})();
